import React, { useState, useEffect } from "react";
import axios from "axios";
import url from "../../function/url";
import DocumentNavbar from "./DocumentNavbar";
import ReactPaginate from "react-paginate";
import "../Document/Table.css";
import Swal from "sweetalert2";
const CertificateRequests = () => {
  const [certificateRequests, setCertificateRequests] = useState([]);
  const [telecallers, setTelecallers] = useState([]);
  const [assignedRequests, setAssignedRequests] = useState([]);
  const [selectedTelecallers, setSelectedTelecallers] = useState({}); // Manage selection
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;

const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });


  // Function to fetch certificate requests
  const fetchCertificateRequests = () => {
    axios
      .get(`${url.path}/get-unassigned-certificates/`)
      .then((response) => {
        setCertificateRequests(response.data);

        // Extract IDs of already assigned requests
        const assignedIds = response.data
          .filter((req) => req.assigned_to) // Check if assigned_to exists
          .map((req) => req.id);

        setAssignedRequests(assignedIds); // Update the state with assigned request IDs
      })
      .catch((error) =>
        console.error("Error fetching certificate requests:", error)
      );
  };

  // Fetch certificate requests when the component mounts
  useEffect(() => {
    fetchCertificateRequests();
  }, []);

  // Fetch telecallers
  useEffect(() => {
    axios
      .get(`${url.path}/get-document-telecallers/`)
      .then((response) => setTelecallers(response.data))
      .catch((error) => console.error("Error fetching telecallers:", error));
  }, []);

  // Handle telecaller assignment
  const handleAssignTelecaller = (certificateId, telecallerId) => {
    axios
      .post(`${url.path}/assign-certificate-to-telecaller/${certificateId}/`, {
        telecaller_id: telecallerId,
      })
      .then((response) => {
        Toast.fire({
          icon: "success",
          title: "Telecaller assigned successfully!",
        });
        // alert(response.data.message);

        // Refetch the certificate requests after successful assignment
        fetchCertificateRequests();

        // Clear the selection for the assigned certificate
        setSelectedTelecallers((prev) => ({
          ...prev,
          [certificateId]: "", // Reset selection for the assigned certificate
        }));
      })
      .catch((error) => {
        console.error("Error assigning telecaller:", error);
        Toast.fire({
          icon: "error",
          title: "Failed to assign telecaller",
        });
        // alert(
        //   error.response?.data?.error ||
        //     "Failed to assign telecaller. Please try again."
        // );
      });
  };
  const handleSearch = (event) => {
    const searchTerm = event.target.value.trim().toLowerCase();
    const rows = document.querySelectorAll("#documentTable tbody tr");

    rows.forEach((row) => {
      const rowText = row.textContent.toLowerCase();
      row.style.display = rowText.includes(searchTerm) ? "" : "none";
    });
  };
  // Pagination logic
  const offset = currentPage * itemsPerPage;
  const currentItems = certificateRequests.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(certificateRequests.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  return (
    <>
      <DocumentNavbar />
      
        <center>
        <h3   style={{ fontSize: "20px", position: "relative", top: "10px" }}>Certificate Requests</h3>
        </center>

        <div className="page-wrapper">
        <div className="input-width">
        <input
          type="text"
          id="search"
          placeholder="Search in table..."
          onInput={handleSearch} // Attach the JavaScript-based search function
          className="search-input"
        />
        </div>
      
      </div>
        {!certificateRequests.length ? (
          <p>No certificate requests available.</p>
        ) : (
          <>
             <div className="table-container">
             <table className="responsive-table" id="documentTable">
              <thead>
                <tr>
                 <th>Employee Name</th>
                  <th>Certificate Type</th>
                  <th>Issuer</th>
                  <th>Date</th>
                  <th>Certificate File</th>
                  <th>Assign Telecaller</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((request) => (
                  <tr key={request.id}>
                   <td>{request.Employee_Name}</td>
                    <td>{request.certificate_type}</td>
                    <td>{request.issuer}</td>
                    <td>
                      {request.uploaded_at
                        ? new Date(request.uploaded_at).toLocaleDateString()
                        : "N/A"}
                    </td>
                    <td>{request.certificate_file ? (
                      <a
                        href={`${url.path}${request.certificate_file}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Open File
                      </a>
                    ) : (
                      "No File"
                    )}</td>
<td>
  <select
    id={`telecaller-select-${request.id}`}
    disabled={assignedRequests.includes(request.id)} // Disable if already assigned
    style={{
      padding: "5px",
      borderRadius: "5px",
      border: "1px solid #ccc",
    }}
  >
    <option value="">-- Select Telecaller --</option>
    {telecallers.map((telecaller) => (
      <option key={telecaller.id} value={telecaller.id}>
        {telecaller.Employee_Name}
      </option>
    ))}
  </select>
</td>

<td>
  <button
    onClick={() => {
      const telecallerId = document.getElementById(`telecaller-select-${request.id}`).value;
      if (telecallerId) {
        // Assign telecaller to request
        handleAssignTelecaller(request.id, telecallerId);
        setAssignedRequests((prev) => [...prev, request.id]); // Update state to mark as assigned
      } else {
        alert("Please select a telecaller before assigning.");
      }
    }}
    disabled={assignedRequests.includes(request.id)} // Disable if already assigned
    style={{
      padding: "8px 12px",
      borderRadius: "5px",
      fontWeight: "bold",
      color: "white",
      backgroundColor: assignedRequests.includes(request.id) ? "green" : "blue",
      border: "none",
      cursor: assignedRequests.includes(request.id) ? "not-allowed" : "pointer",
    }}
  >
    {assignedRequests.includes(request.id) ? "Assigned" : "Assign"}
  </button>
</td>

                  
                  </tr>
                ))}
              </tbody>
            </table>
             </div>
            

            {certificateRequests.length > itemsPerPage && (
              <ReactPaginate
                previousLabel={"← Previous"}
                nextLabel={"Next →"}
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            )}
          </>
        )}
      
    </>
  );
};

export default CertificateRequests;
